// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3xZeJ","vLegacy":"SelectSecondary_vLegacy__1eDdW","error":"SelectSecondary_error__xi1RX","disabled":"SelectSecondary_disabled__1H-ZL"};